import type { TMessages } from '@/types/TMessages'

export const messages = {
  button: {
    submitApplication: 'Подать заявку',
  },
} satisfies TMessages
